import { AbstractControl, ValidatorFn } from '@angular/forms';

export const aoMenosUmPreenchidoValidator = (
  ...argumentos: string[]
): ValidatorFn => {
  return (control: AbstractControl) => {
    for (let argumento of argumentos) {
      const valor = control.get(argumento)?.value;

      if (valor === null) {
        continue;
      }

      if (typeof valor === 'string' && valor.length > 0) {
        return null;
      }

      if (typeof valor === 'number' && valor !== 0) {
        return null;
      }
    }
    return { aoMenosUmPreenchido: true };
  };
};
